
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AIChatbot } from './components/feature/AIChatbot';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <AIChatbot />
    </BrowserRouter>
  );
}

export default App;
